import React, { Component } from 'react';
import SpinningGear from "./loaders/SpinningGear";

export default class LoaderFullPage extends Component {
	static defaultProps = {
		text: null,
		showLoading: true,
	};

	render() {
		const { text, showLoading } = this.props;
		return (
			<div className='full_page_loader'>
				<div>
					{!!text && <h2>{text}</h2>}
					{showLoading &&
					<SpinningGear/>
					}
				</div>
			</div>
		);
	}
}